import React from 'react';

import './buttonWhatsApp.css';

export default function ButtonWhatsApp() {
  return (
    <div className="button-whats-app" title="Entre em contato conosco via WhatsApp">
      <a
        href="https://api.whatsapp.com/send?phone=5511933550837&text=Olá, vi seu website e me interessei por seus produtos, gostaria de mais informações. Podemos conversar?"
        target="_blank"
        rel="noopener noreferrer"
      >
        <i className="fa fa-whatsapp icon"></i>
      </a>
    </div>
  )
}
